<ng-container>
    <div class="section form-group">
        <div class="section-header sub-section-header">
            <label class="section-title">{{'paClaim.accidentDetails.title' | translate}}</label>
            <span class="section-header-desc">{{'paClaim.accidentDetails.subTitle' | translate}}</span>
        </div>
        <div class="section-content">
            <div class="sub-section">
                <label class="section-header-desc">{{'paClaim.accidentDetails.subTitle' | translate}}</label>
                <div class="row">
                    <div class="col col-xs-12 col-lg-7">
                        {{'paClaim.accidentDetails.occupation' | translate}}
                    </div>
                    <div class="col col-xs-12 col-lg-5 content">
                        {{occupation}}
                    </div>
                </div>

                <div class="row">
                    <div class="col col-xs-12 col-lg-7">
                        {{'paClaim.accidentDetails.accidentDate' | translate}}
                    </div>
                    <div class="col col-xs-12 col-lg-5 content">
                        {{getDateTime(claimPA.getAccidentDetails().getAccidentDate())}}
                    </div>
                </div>

                <div class="row">
                    <div class="col col-xs-12 col-lg-7">
                        {{'paClaim.accidentDetails.accidentDescription2' | translate}}
                    </div>
                    <div class="col col-xs-12 col-lg-5 content">
                        {{claimPA.getAccidentDetails().getAccidentDescription()}}
                    </div>
                </div>
            </div>

            <div class="section-header sub-section-header">
                <span class="section-header-desc">{{'paClaim.injuryDetails.title' | translate}}</span>
            </div>

            <div class="sub-section adjust-top1">
                <label class="section-header-desc">{{'paClaim.injuryDetails.title' | translate}}</label>
                <div class="row">
                    <div class="col col-xs-12 col-lg-7">
                        {{'paClaim.injuryDetails.labelParts' | translate}}
                    </div>
                    <div class="col col-xs-12 col-lg-5 content">
                        {{injuredParts}}
                    </div>
                </div>

                <div class="row">
                    <div class="col col-xs-12 col-lg-7">
                        {{'paClaim.injuryDetails.hasEncounteredSimilarIncident' | translate}}
                    </div>
                    <div class="col col-xs-12 col-lg-5 content">
                        {{returnYesOrNo(claimPA.getInjuryDetails().getHasEncounteredSimilarIncident())}}
                    </div>
                </div>

                <div *ngIf="this.claimPA.getInjuryDetails().getHasEncounteredSimilarIncident()" class="row">
                    <div class="col col-xs-12 col-lg-7">
                        {{'paClaim.injuryDetails.placeOfIncident' | translate}}
                    </div>
                    <div class="col col-xs-12 col-lg-5 content">
                        {{claimPA.getInjuryDetails().getPlaceOfIncident()}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
